/* global Modernizr */
import * as eventDispatcher from 'eventDispatcher';
import { getAccessToken } from 'gucciAuth';
import { ga4SendGenericEvent, safeGTMuaEventsPusher } from '../utils/gtm-utilities.es6';

const DATA_BINDED_ATTR = 'data-binded';

const hasEventsAttached = node => node.getAttribute(DATA_BINDED_ATTR) === 'true';

const getAppGroups = () => {
    const groups = Array.from(document.querySelectorAll('[data-app=group]'));
    return groups.filter(group => !hasEventsAttached(group));
};

const addAppAdvToMobileMenu = async () => {
    const appAdv = document.getElementById('gucciAppAdv');
    const isUserLogged = await getAccessToken();

    if (appAdv && isUserLogged) {
        const appAdvTemplateContent = appAdv.content.cloneNode(true);
        appAdvTemplateContent.querySelector('div').setAttribute('data-analyticsLabel', 'navigation');
        const myAccountItem = document.querySelector('.item-secondary.create-account-item');

        if (myAccountItem) {
            myAccountItem.parentNode.insertBefore(appAdvTemplateContent, myAccountItem.nextSibling);
        }
    }
};

const attachMobileHandlers = groups => {
    const html = document.querySelector('html');
    const isAndroid = html.classList.contains('android');
    const isIOS = Modernizr.ios;
    const appLinkAndroid = document.querySelector('#gucciAndroidAppLink').getAttribute('value');
    const appLinkApple = document.querySelector('#gucciIOsAppLink').getAttribute('value');
    if (isAndroid || isIOS) {
        groups.forEach(group => {
            const btnTrigger = group.querySelector('[data-app=trigger]');
            btnTrigger.setAttribute('role', 'link');
            btnTrigger.removeAttribute('aria-expanded');
            btnTrigger.removeAttribute('aria-controls');
            btnTrigger.addEventListener('click', e => {
                e.preventDefault();
                const link = isAndroid ? appLinkAndroid : appLinkApple;
                window.open(link, '_blank');
            });
        });
    }
};

const closeAppLinks = (group, trigger, links) => {
    trigger.setAttribute('aria-expanded', 'false');

    trigger.classList.remove('active');
    links.classList.remove('active');
};

const attachUIHandlers = groups => {
    groups.forEach(group => {
        const groupTrigger = group.querySelector('[data-app=trigger]');
        const groupLinks = group.querySelector('[data-app=links]');

        if (groupTrigger && groupLinks) {
            const handleGroup = () => {
                groupTrigger.setAttribute('aria-expanded', 'true');
                groupTrigger.classList.add('active');
                groupLinks.classList.add('active');
            };
            group.addEventListener('mouseenter', handleGroup);
            group.addEventListener('click', handleGroup);
            group.addEventListener('mouseleave', () => closeAppLinks(group, groupTrigger, groupLinks));
            groupLinks.addEventListener('blur', () => closeAppLinks(group, groupTrigger, groupLinks));
        }
    });
};

const attachAnalytics = groups => {
    groups.forEach(group => {
        const label = group.dataset.analyticslabel;
        group.addEventListener('click', () => {
            // Event Category: app banner
            // Event Action: banner shown
            // Event Label: thank you page / navigation / etc.
            // Event type: Non-interaction event

            // Event Category: app banner
            // Event Action: click on banner
            // Event Label: thank you page / navigation / etc.
            // Event type: Interaction event
            ga4SendGenericEvent('gucciapp.appbanner.click', { label });
            safeGTMuaEventsPusher('interactionEvent', 'app banner', 'click on app banner', label);
        });
        const observer = new IntersectionObserver(
            function(entries) {
                if (entries[0].isIntersecting === true) {
                    ga4SendGenericEvent('gucciapp.appbanner.show', { label });
                    safeGTMuaEventsPusher('nonInteractionEvent', 'app banner', 'app banner shown', label);
                    this.disconnect();
                }
            },
            { threshold: [0] }
        );

        observer.observe(group);
    });
};

const attachPopupEvent = groups => {
    groups.forEach(group => {
        const closeBtn = group.querySelector('[data-app=closePopup]');
        if (closeBtn) {
            closeBtn.addEventListener('click', () => {
                document.body.classList.add('app-adv_orderconfirmation-closed');
                group.classList.add('app-adv_closed');
            });
        }
    });
};

const attachHandlers = () => {
    const appGroups = getAppGroups();
    attachMobileHandlers(appGroups);
    attachUIHandlers(appGroups);
    attachAnalytics(appGroups);
    attachPopupEvent(appGroups);
    appGroups.forEach(group => group.setAttribute(DATA_BINDED_ATTR, 'true'));
};

const handleHeaderAccount = () => {
    eventDispatcher.handleLoadedModules('headerMenuMobileAccount', () => {
        attachHandlers();
    });
};

const initGucciApp = () => {
    addAppAdvToMobileMenu();
    attachHandlers();
    handleHeaderAccount();
};

if (document.readyState === 'complete' || document.readyState === 'loaded' || document.readyState === 'interactive') {
    initGucciApp();
} else {
    window.addEventListener('DOMContentLoaded', initGucciApp);
}
